<template>
    <div>
        <v-app-bar color="#c1680e" dark fixed flat>
            <v-btn @click="drawer=true" class="mt-0 ml-2" fab color="#ffffff" small>
                <v-icon color="#c1680e">toc</v-icon>
            </v-btn>
            <v-row>
                    <v-col cols="6" class="text-end">
                        <div class="ml-10">
                            <strong>{{ modulo }}</strong>
                        </div>
                    </v-col>
                    <v-col cols="6" class="text-end">
                        <v-icon class="mt-n1">person</v-icon>
                        <strong class="ml-2">{{ usu }}</strong>
                    </v-col>
                </v-row>
        </v-app-bar>
        <component v-bind:is="componente" :usu="usu" :contrato="contrato"></component>

        <v-navigation-drawer v-model="drawer" absolute temporary color="#c1680e" dark>
            <v-list-item>
                <v-btn class="mt-5" @click="drawer=false" fab color="#000" dark small>
                    <v-icon>arrow_back</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list dense>
                <v-list-item v-for="item in myMenu" :key="item.title" link @click="goMenu(item)" class="mt-n2">
                    <v-list-item-icon>
                        <div v-if="parseInt(item.id)==0 || parseInt(item.id)==10 || parseInt(item.id)==20">
                            <v-list-item-title><h6 class="mt-2">{{ item.title }}</h6></v-list-item-title>
                        </div>
                        <div v-else>
                            <v-icon class="ml-5">{{ item.icon }}</v-icon>                
                        </div>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <div v-if="parseInt(item.id)!=0 && parseInt(item.id)!=10 && parseInt(item.id)!=20">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </div>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <v-btn @click="goLogin()" block color="#000" dark>
                        Cerrar Sesion
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>  
    </div>
</template>
<script>
import Bienvenido from "@/components/Bienvenido.vue";
import Usuarios from "@/components/Usuarios.vue";
import Agenda from "@/components/Agenda.vue";
import Servicios from "@/components/Servicios.vue";
import Clientes from "@/components/Clientes.vue";
import Productos from "@/components/Productos.vue";
import FormaPago from "@/components/FormaPago.vue";
import Ventas from "@/components/Ventas.vue";
import Proceso from "@/components/Proceso.vue";
import Pagos from "@/components/Pagos.vue";
import Liquidacion from "@/components/Liquidacion.vue";
import Caja from "@/components/Caja.vue";
import Reporte from "@/components/Reporte.vue";
export default {
  name: 'Acceso',
  components:{Usuarios, Bienvenido, Agenda, Servicios, Clientes, Productos, FormaPago, Ventas, Proceso, Pagos, Liquidacion, Caja, Agenda, Reporte},
  data: () => ({
    usu:'',
    contrato:'',
    drawer:false,
    myMenu:[
        {id:10, modulo:"", title:'PROCESS', icon:'play_arrow'},
        {id:11, modulo:"Proceso", title:'Venta Servicio', icon:'play_arrow'},
        {id:12, modulo:"Ventas", title:'Venta Productos', icon:'play_arrow'},
        {id:13, modulo:"Caja", title:'Flujo Caja', icon:'play_arrow'},
        {id:13, modulo:"Agenda", title:'Agenda Solarium', icon:'play_arrow'},
        //{id:15, modulo:"Pagos", title:'Pago Servicio', icon:'play_arrow'},
        {id:14, modulo:"Liquidacion", title:'Liquidaciones', icon:'play_arrow'},

        {id:0, modulo:"", title:'SETUP', icon:'play_arrow'},
        {id:1, modulo:"Usuarios", title:'Usuarios', icon:'play_arrow'},
        //{id:2, modulo:"Agenda", title:'Agenda', icon:'account_box'},
        {id:3, modulo:"Servicios", title:'Servicios', icon:'play_arrow'},
        {id:4, modulo:"Clientes", title:'Clientes', icon:'play_arrow'},
        {id:5, modulo:"Productos", title:'Productos', icon:'play_arrow'},
        {id:6, modulo:"FormaPago", title:'Forma de Pago', icon:'play_arrow'},

        {id:20, modulo:"", title:'REPORTS', icon:'play_arrow'},
        {id:21, modulo:"Reporte", title:'Reportes', icon:'play_arrow'},
    ],
    content:0,
    modulo:'BIENVENIDO',
    componente:'Bienvenido',

  }),
    created() { 
    window.addEventListener("onload", e => { 
      e.preventDefault(); 
      // Oculte el evento para que pueda activarse más tarde. 
      this.deferredPrompt = null; 
    });
  }, 

  async mounted(){
    const myUser = localStorage.getItem('myuser');
    const myContrato = localStorage.getItem('mycontrato');
    if(myUser!=null && myContrato!=null){
        this.usu = myUser;
        this.contrato = myContrato;
    }
  },
  methods:{
    goMenu(menu){
        if(parseInt(menu.id)!=0 && parseInt(menu.id)!=10 && parseInt(menu.id)!=20){
            this.modulo=menu.title.toUpperCase();
            this.componente=menu.modulo;
            this.drawer=false;
        }
    },
    goLogin(){
        localStorage.removeItem('mytoken');
        localStorage.removeItem('myuser');
        localStorage.removeItem('mycontrato');
        localStorage.removeItem('timeuser');
        this.$router.push({name:'Login'})
        //window.location.href = '/';
    }
  }
}
</script>
